// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import Waypoint from 'react-waypoint'

// Redux:
import { setCurrentlyViewedPage, registerPageView } from 'actions/page'

class Content extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			waypointEntered: false
		}
	}

	handleWaypointEnter = () => {
		const { dispatch, currentlyViewedPage } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		const { waypointEntered } = this.state

		if ( page.slug != currentlyViewedPage.slug ) {
			// Set this post as the current:
			dispatch( setCurrentlyViewedPage( page.slug ) )
		}

		if ( ! waypointEntered || page.slug != currentlyViewedPage.slug ) {
			dispatch( registerPageView( page.id ) )

			this.setState({
				waypointEntered: true
			})
		}
	}

	render() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page
		let intro = null

		const content = (
			<div className="page-section">
				<div className='content-body-text' dangerouslySetInnerHTML={ { __html: page.content.rendered } }></div>

				{ page.notes && page.notes.rendered &&
					<div className='content-notes' dangerouslySetInnerHTML={ { __html: page.notes.rendered } }></div>
				}
			</div>
		)

		if ( page.intro && page.intro.rendered ) {
			intro = (
				<div className="content-intro" dangerouslySetInnerHTML={ { __html: page.intro.rendered } } />
			)
		}

		return (
			<div className="content-body-wrap">
				<Waypoint
					onEnter={ this.handleWaypointEnter }
				/>

				<div className="content-body">
					{ intro }
					{ content }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		currentlyViewedPage: state.page.currentlyViewedPage
	}
}

export default connect( mapStateToProps )( Content )
